import React, {Component} from 'react';
import {matchRoutes} from 'react-router-config';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import * as Actions from 'auth/store/actions';
import {API} from '../../../config';
import Utils from "../../../main/custom/utils";
import {withContext} from "../../../main/custom/StateProvider";

let redirect = false;

class FuseAuthorization extends Component {
// eslint-disable-next-line
    constructor(props)
    {
        super(props);

        /*var auth = Utils.readCookie('auth');
        if(auth != null && auth.length > 5){
          auth = JSON.parse(auth);
          this.props.refreshLogin(auth);
        }*/
        this.checkAuth()
    }

    componentDidUpdate(prevProps)
    {
        /**
         * If route is changed
         * Update auths
         */
        if ( !_.isEqual(this.props.location.pathname, prevProps.location.pathname) )
        {
            this.checkAuth();
        }
    }

    componentWillMount(){
        this.checkAuth();
    }
    
    isEmpty(str){
        return (!str || 0 === str.length);
    }

    checkAuth()
    {
        console.log('check auth:',this.props.user.role);

        const contraller = this;
        const matched = matchRoutes(this.props.routes, this.props.location.pathname)[0];
    
            if ( matched && matched.route.auth && matched.route.auth.length > 0 )
            {
                var intersect = _.intersection(this.props.user.role, matched.route.auth);
                if(this.props.user.role === 'unauthenticated' && !this.isEmpty(window.localStorage.getItem('feathers-jwt'))){
                    if(window.localStorage.getItem('feathers-jwt')) {
                        console.log('reauth necessary',window.localStorage.getItem('feathers-jwt'));
                        API.authenticate({
                            strategy: 'jwt',
                            accessToken: window.localStorage.getItem('feathers-jwt')
                        }).then((response)=>{
                            console.log('reauthed:',response);
                            //API.passport.verifyJWT(response.accessToken).then((data)=>{
                              //  API.service('investors').find().then((u)=>{
                            let u = response.investor;
                                    var payload = {
                                        data: {
                                            data: {
                                                'displayName': u._firstname + ' ' + u._surname,
                                                'photoURL': 'assets/images/avatars/profile.jpg',
                                                'email': u._email,
                                                'ident': u._account,
                                                'id_number': u._id,
                                                'userRole': u._userRole,
                                                settings: {}
                                            },
                                            role: JSON.parse(u._permissions),
                                            userRole: u._userRole,
                                            affiliate: u._affiliate,
                                        }
                                    };

                                    let perms = u._permissions;

                                    if(Utils.isJSON(perms)){
                                        perms = JSON.parse(u._permissions);
                                    }

                                    contraller.props.context.update({
                                        authenticated: true,
                                        username: u._email,
                                        displayName: u._firstname + ' ' + u._surname,
                                        displayRole: u._userRole,
                                        permissions: (Array.isArray(perms)) ? perms : ['none'],
                                    })
                                    contraller.props.setUserData(payload.data);
                            //    });
                            //})
                        }).catch((e)=>{
                            console.log("Not Authenticated:",e);
                            this.props.history.push({
                                pathname: '/'
                            });
                        })
                    } else {
                        console.log("Not Authenticated");
                        this.props.history.push({
                            pathname: '/'
                        });
                    }
                } else {
                    this.handleRedirect(intersect);
                } 
                
            }


    }

    handleRedirect(intersect){
        if(intersect.length === 0){
            redirect = true;
            if ( this.props.user.role === 'unauthenticated' )
            {
                window.location = '/login';
                /*this.props.history.push({
                    pathname: '/login',
                    state   : {redirectUrl: this.props.location.pathname}
                });*/
            }
            else
            {
                this.props.history.push({
                    pathname: '/'
                });
            }
        }
    }

    shouldComponentUpdate(nextProps)
    {
        if ( redirect )
        {
            redirect = false;
            return false;
        }
        else
        {
            return true;
        }
    }

    render()
    {
        const {children} = this.props;

        return (
            <React.Fragment>
                {(this.props.context.authenticated || this.props.location.pathname==="/login" || this.props.location.pathname==="/") &&
                <React.Fragment>
                    {children}
                </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch)
{
  return bindActionCreators({
    setUserData: Actions.setUserData,
    setUserDataFromDB: Actions.setUserDataFromDB,
  }, dispatch);
}

function mapStateToProps({fuse, auth})
{
    return {
        user: auth.user
    }
}

export default withContext(withRouter(connect(mapStateToProps, mapDispatchToProps)(FuseAuthorization)));


